// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  color: red;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/administration/request-line-types/manage-request-type/manage-request-type.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,eAAA;AACJ","sourcesContent":[".error {\n    color: red;\n    font-size: 12px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
